import React, { useState } from 'react';
import { connect } from "react-redux";
import historyHandler from "jd-library/historyHandler";
import withRipple from "jd-library/withRipple";
import ImageLoader from '../../../common/Image/ImageLazyWrapper';
import style from './categoryListItem.scss';
import { staticImageDomains } from '../../../../config/config';
import FormCheck from 'jd-library/FormCheck';
import { selectCatItem } from "../../../actions/items";
import {travObjBrandCategory} from "../../../utills";

const image = {
    height: '1.75rem',
    width: '1.75rem',
    borderRadius: '4px',
    marginRight: '12px',
    marginLeft: '2px',
    position: 'relative',
    display: 'inline-block',
    zIndex: '1'
    // border: '1px solid #EDEDED'
}

const imageProps = {
    height: '100%',
    width: '100%',
    borderRadius: '4px'
}
let prevValue, selectedChild;
const ListItem = (props) => {
    // const [selectItem,updateSelectItem] = useState(false); 
    let dataToPrint = props.data;
    if (!dataToPrint) {
        dataToPrint = {};
    }
    let existingPuvIds = props.productData.selectedProductGroupIds || '';
    if (existingPuvIds) {
        let existingCatIds = existingPuvIds.split(',');
        dataToPrint.disabled = (existingCatIds.indexOf(dataToPrint.productGroupId.toString()) != -1 && dataToPrint.productGroupId != props.selectedCatID);
    }
    if (props.selectedCatID && dataToPrint.productGroupId == props.selectedCatID) {
        dataToPrint.isSelected = true;
        props.selectCategory(dataToPrint);
        selectedChild = dataToPrint;
    }
    let imageSrc;
    let displayName;
    let imageTextLogo;
    let imgClass = '';
    imageSrc = dataToPrint.imageUrl;
    if(!props.useCategorySlider){
        imgClass = imageSrc ? "" : style["no-image"];
        imageSrc = imageSrc ? staticImageDomains[0] + '/groups' + imageSrc : "https://image1.jdomni.in/jdomni_email/NOIMAGE_2002211157.png";
    }else{
        imgClass = imageSrc ? "" : props.fromDiscount ? style["no-image"] : "";
        imageSrc = imageSrc ? staticImageDomains[0] + '/groups' + imageSrc : props.fromDiscount ? "https://image1.jdomni.in/jdomni_email/NOIMAGE_2002211157.png" : null;
    }
    displayName = dataToPrint.productGroupName;
    if (!imageSrc) {
        let iconText = props.displayLabel ? props.displayLabel : displayName
        let iconVariable = iconText.substring(0, 1).toUpperCase();
        imageTextLogo = "icon-logo" + (isNaN(iconVariable) ? iconText.substring(0, 1).toUpperCase() : "Hash");
    }
    let ref = React.useRef();

    const imageLoaderProps = {
        imgClass: imgClass,
        style: imageProps,
        finalImageSrc: imageSrc,
        loadOrignal: true,
        retainRandomColor: true,
        lazyLoadProps: {
            overflow: true,
            once: true,
            debounce: 400,
            scrollContainer: props.scrollRef && props.scrollRef.current ? props.scrollRef.current._outerRef : undefined
        }
    }
    // const closeChidCatSlider = () =>{
    //     toggleChildCat(false);
    //     historyHandler.closeCurrent();
    // }
    const onSelectChild = (e, value) => {
        e.preventDefault();
        e.stopPropagation();
        props.updateChild(value);
        props.toggleChildCat(true);
    }
    const label = /* useMemo(() => { */
        /* console.log('Updated Here Check');
        return  */(
            <>
                <div style={image} className={dataToPrint.isSelected ? style['img-selected'] : ''}>
                    {dataToPrint.isSelected && <div style={{ height: '100%', width: '100%', background: 'rgba(19,144,211,.2)', 'border-radius': '4px', 'z-index': '2', position: 'absolute' }}>
                    </div>}
                    {imageSrc ?
                    <ImageLoader
                        {...imageLoaderProps}
                    /> : (<div className={style['image-logo-text']+" "+(props.useCategorySlider ? style["image-round1"] : "")}><div className={style['image-logo'] + imageTextLogo} ></div></div>)}
                </div>
                <div style={{ fontSize: "0.875rem", color: "#414E59", fontWeight: "400", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", display: "inline-block", cursor:"pointer" }} className={dataToPrint.isSelected ? style['text-selected'] : ''} >
                    {props.displayLabel ? props.displayLabel : displayName}
                </div>
                {(dataToPrint && dataToPrint.level != 2 && !props.useCategorySlider && dataToPrint.productGroupName != 'Other') ? (<div className={style['create-category-plus']} onClick={(event) => { onSelectChild(event, dataToPrint) }}><div className={style['select-child-plus']}><div className='icon-plus'> </div></div></div>) : null}
            </>
        )/* }, [dataToPrint, props.nameKey, props.displayLabel, props.scrollRef]) */;
    let paddingLeft = dataToPrint.level ? ((dataToPrint.level * 30) + 15) : 15;
    // if(props.useCategorySlider){
    //     paddingLeft = (dataToPrint.level*30);
    // }else{
    //     paddingLeft = dataToPrint.level ? ((dataToPrint.level * 30) + 15) : 15;
    // }
    let linesLeft = paddingLeft;
    let lines = [];
    let linesToDraw = dataToPrint.linesToDraw;
    let printArr = dataToPrint.linesArr;
    for (let i = 0; i < linesToDraw; i++) {
        let styleupdate = {
            left: (dataToPrint.level == 1 && i == 0) ? '30px' : ((linesLeft - 30 * i) - 15) + 'px',
            height: (props.itemSize) + 'px',
            top: 0,
            borderLeft: '1px dashed #d5d5d5'
        };
        if (!printArr[linesToDraw - i - 1]) {
            styleupdate.borderLeft = '';
        }
        lines.push(<div style={styleupdate} className={style['sibling-dummy-lines']} />);
    }
    
    const onSelectCat = (value) => {
        if(props.useCategorySlider){
            return;
        }
        if (prevValue) {
            prevValue.isSelected = false;
        }
        if (selectedChild) {
            selectedChild.isSelected = false;
        }
        props.selectCategory(value);
        props.updateSelectedCatID(null);
        // updateSelectItem(!selectItem);
        value.isSelected = true;
        prevValue = value;
        // props.closeCatSlider();
        // historyHandler.closeCurrent();
    }
    
    let borderWidth = dataToPrint.level ? paddingLeft + 55 : paddingLeft + 55;
    const newWidth = 'calc(100% - ' + borderWidth + 'px)';

    return (
        <div ref={ref} style={{ paddingLeft: paddingLeft + 'px' }} className={style['listing-div'] + ' ' + (dataToPrint.disabled ? style['disable-click'] : '') + ' ' + (!props.useCategorySlider ? style['listing-div-product'] : '')} onClick={() => { onSelectCat(dataToPrint) }}>
            {props.useCategorySlider ? (
                <FormCheck rippleColor='rgba(33, 37, 41, .1)' 
                label={label} 
                onChange = {(e) => {
                    let newObj = {...props.data};
                    newObj.isSelected = e.target.checked;
                    newObj.curObjKey = dataToPrint.objKey;
                    //selectCatItem(newObj,newObj.isSelected);
                    props.selectCatItem(newObj);
                }}
                checked={dataToPrint.is} 
                className={style['form-li']} 
                type='circle' 
            />
            ) : label}
            {<div className={style['cat-border-bottom']} style={{ width: newWidth, left: (dataToPrint.level ? paddingLeft + 40 : paddingLeft + 40) + 'px', top: (props.itemSize) }}></div>}
            {(dataToPrint.level == 0) ? null : <div style={{ left: (paddingLeft - 15) + 'px', height: ((props.itemSize / 2)) + 'px' }} className={style['parent-dummy-div']} />}
            {(dataToPrint.childProductGroupsCommand) ? <div style={{ height: ((props.itemSize / 2) - 10) + 'px', left: (paddingLeft + 15) + 'px', top: (props.itemSize - 18) }} className={style['last-div']} /> : null}
            <>
                {lines}
            </>
        </div>

    )
}

const mapStateToProps = (state, props) => {
    let currentObject = travObjBrandCategory(state.items.editCategoryData, props.data.objKey);
    return {
        itemInfo: state.items.itemInfo,
        productData: state.products.editProduct,
        ...props,
        isSelected: currentObject.is
    }
}

const MemoizedListItem = React.memo((props) => {
    return (
        <ListItem
            {...props}
        />
    )
}, (prev, next) => {
    if(prev.isSelected !== next.isSelected || prev.scrollRef !== next.scrollRef || !prev.useCategorySlider){
        return false;
    } else {
        return true;
    }
});
const ConnectedListItem = connect(
    mapStateToProps, {
        selectCatItem
    }
)(MemoizedListItem);

export default ConnectedListItem